import CompensationList from 'components/elements/compensation/CompensationList'
import TelIcon from 'components/elements/icons/TelIcon'
import CallModal from 'components/elements/modal/CallModal'
import Text from 'components/elements/texts/Text'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import DOMAIN from 'constants/domains'
import { VEHICLE_STATE } from 'constants/qnState'
import { REQUEST_AREA_HEIGHT, TRACKING_AREA_HEIGHT } from 'constants/size'
import React from 'react'
import { QnStateProps } from 'states/QnState'
import styled from 'styled-components'
import { getDomain , isKsDomain, isSaficDomain} from 'utils/domain'
import Precautions from 'components/elements/items/Precautions'
import FooterArea from '../RequestTemplate/FooterArea'
import GlobalFooterArea from '../RequestTemplate/GlobalFooterArea'
import ConfirmContentArea from './ConfirmContentArea'

/**
 * 要請者の入力情報表示エリア
 */
// const domain = {
//   [DOMAIN.SAFIC]: 'safic',
//   [DOMAIN.SJ]: 'sj',
// }[getDomain()]

const RequestArea: React.FC<RequestAreaProps> = (props) => {
  const state = props.state

  const compensationItem = isKsDomain() ? CLIENT_SETTINGS.messages.compensation[state.productKbnCd] : 
  isSaficDomain() ? state.vehicleState === VEHICLE_STATE.EMPTY_FUEL
  ? CLIENT_SETTINGS.messages.compensation.outOfFuel
  : CLIENT_SETTINGS.messages.compensation.normal :{
    [DOMAIN.SJ]: CLIENT_SETTINGS.messages.compensation[state.productKbnCd],
  }[getDomain()]

  return (
    <StyledRequestArea trackingContent={props.trackingContent}>
      <BarArea>
        <Bar />
        {props.trackingContent}
      </BarArea>
      <CallModal isTransitionReAccess={false}>
        <TelArea>
          <TelIcon />
          <TelText color={CLIENT_SETTINGS.colors.main}>
            要請キャンセル・ヘルプ
          </TelText>
        </TelArea>
      </CallModal>
      <Precautions />

      <TitleArea>
        <Text bold>要請情報</Text>
      </TitleArea>
      <ConfirmContentArea state={state} isRequest />
      {/* {domain === 'safic' ? (
        <TitleArea>
          <Text bold>補償内容</Text>
        </TitleArea>
      ) : (
        <SjTitleArea>
          <Text color={CLIENT_SETTINGS.colors.textForMainBackground} bold>
            補償内容
          </Text>
        </SjTitleArea>
      )} */}

      <CompensationList items={compensationItem} isRequested />
      <FooterArea />
      <GlobalFooterArea />
    </StyledRequestArea>
  )
}

export type RequestAreaProps = {
  state: QnStateProps
  trackingContent?: React.ReactNode
}

const Bar = styled.div`
  width: 80px;
  height: 3px;
  margin: 10px auto;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 40px;
`

const BarArea = styled.div`
  background: var(--color-content-background);
  border-top: 1px solid var(--color-border);
  border-bottom: 2px solid var(--color-border);
`

const TelArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  background: var(--color-content-background);
`

const TelText = styled(Text)`
  margin-left: 6px;
`
const TitleArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 43px;
  background: var(--color-background);
  border-top: 1px solid var(--color-border);
`

// const SjTitleArea = styled(TitleArea)`
//   background: var(--color-icon-partner);
// `

const StyledRequestArea = styled.div<{
  trackingContent?: React.ReactNode
}>`
  position: relative;
  top: ${(props): string =>
    props.trackingContent ? TRACKING_AREA_HEIGHT : REQUEST_AREA_HEIGHT};
  background: var(--color-background);
`

export default RequestArea
